let pendingCount = 0;
let handler = null;

export const setLoadingHandler = (nextHandler) => {
  handler = typeof nextHandler === "function" ? nextHandler : null;
  if (handler) handler(pendingCount);
};

const notify = () => {
  if (handler) handler(pendingCount);
};

export const startLoading = () => {
  pendingCount += 1;
  notify();
};

export const stopLoading = () => {
  pendingCount = Math.max(0, pendingCount - 1);
  notify();
};

export const resetLoading = () => {
  pendingCount = 0;
  notify();
};
